export default __webpack_public_path__ + "static/media/L_LVT.cb5764e3.jpg";